module.exports = __webpack_public_path__ + "img/arrow-down-red.1895c141.svg";